/* stylelint-disable property-no-vendor-prefix */
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { shadows } from '@doltech/ui/lib/figma/shadows';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import * as React from 'react';
import styled from 'styled-components';

const Main = styled.div<{ colorString: string }>`
  background: ${(p) => p.colorString};
  border-radius: 8px;
  padding: 32px 16px;
  box-shadow: ${shadows.zIndex3};

  display: grid;
  place-items: center;
  gap: 32px;

  .card-text,
  .image-wrapper {
    white-space: pre-wrap;
    word-break: break-word;
    text-align: center;
  }
  .image-wrapper {
    width: 124px;
    border-radius: 8px;
    overflow: hidden;

    img {
      object-fit: cover;
      width: 100%;
    }
  }
  .title {
    padding: 10px 12px;
    background-color: ${colorsV2.white100};
    border-radius: 20px;

    h2 {
      background: linear-gradient(180deg, #7bafe0 -31.72%, #eb4343 121.07%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
`;

interface FactCardProps {
  colorString: string;
  text: string;
  imageUrl: string;
}

export const FactCard = ({ colorString, text, imageUrl }: FactCardProps) => {
  return (
    <Main colorString={colorString} className="fact-card">
      <div className="title">
        <ResponsiveTypography.Text variant="bold/14-20" as="h2">
          SỰ THẬT BẠN CHƯA BIẾT
        </ResponsiveTypography.Text>
      </div>
      <Typography.Paragraph color="white100" variant="semi-bold/20" className="card-text">
        {text}
      </Typography.Paragraph>
      <div className="image-wrapper">
        <img
          src={imageUrl || 'https://dummyimage.com/124x124/fff/000.png?text=Insert%20image'}
          alt="fact"
        />
      </div>
    </Main>
  );
};
